export const CampaignListWithPaggination = (state) => {
    return state?.campaigns?.campaigns;
};
export const CampaignIsLoading = (state) => {
    return state?.campaigns?.showLoading;
};
